import { TaskType } from '@wm-front/client/graphql'

declare const $localize: any

export function i18nTaskType(val: TaskType): string {
  let res = ''

  switch (val) {
    case TaskType.Annual:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeAnnualLabel:Annuelle`
      break
    case TaskType.Breakdown:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeBreakdownLabel:Panne`
      break
    case TaskType.ClientAppointment:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeTrappedClientAppointmentLabel:Rendez-vous client`
      break
    case TaskType.ControlOfficeAppointment:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeControlOfficeAppointmentLabel:Rendez-vous bureau de contrôle`
      break
    case TaskType.Previsit:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypePrevisitLabel:Pré-visite`
      break
    case TaskType.Regular:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeRegularLabel:Régulière`
      break
    case TaskType.Repair:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeRepairLabel:Réparation`
      break
    case TaskType.SecurityAudit:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeSecurityAuditLabel:Étude de sécurité`
      break
    case TaskType.Semiannual:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeSemiAnnualLabel:Semestrielle`
      break
    case TaskType.TrappedPassenger:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeTrappedPassengerLabel:Passager bloqué`
      break
    case TaskType.Quarterly:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeQuarterlyLabel:Trimestrielle`
      break
    case TaskType.Handover:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeHandoverLabel:Handover`
      break
    case TaskType.IotInstallation:
      res = $localize`:Label | Type of task defined throughout the app@@i18nTaskTypeIoTInstallationLabel:Installation IoT`
      break
    default:
      res = $localize`:Label | Type of task undefined throughout the app@@i18nTaskTypeUndefinedLabel:inconnu`
  }

  return res
}
